// import { Localization } from 'expo'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import BackendAdapter from 'i18next-multiload-backend-adapter'

import createI18nBackend, { loadMulti } from './i18nBackend'
import AppConfig from './AppConfig'
import * as Sentry from '@sentry/react-native'
import { getAppRegion } from 'storage/useRemoteConfigParams'
const customBackend = createI18nBackend(i18n)

// Make resources available for i18n at the start
const defaultNS = [
  'app',
  'attributes',
  'auth',
  'banner',
  'common',
  'configuration',
  'customer',
  'customization',
  'deals-configuration',
  'deals-modals',
  'deals-recommendations',
  'deals-toasts',
  'deals-types',
  'eyetest',
  'frame',
  'home',
  'intro',
  'measurement',
  'modals',
  'order',
  'payment',
  'prescription',
  'recommendations',
  'staff',
  'status',
  'steps',
  'summary',
  'tags',
  'toasts',
  'translation',
  'types',
  'ui-steps',
  'ui-tags',
  'ui',
  'user',
  'vision',
]

const logged: Record<string, boolean> = {}

const region = getAppRegion()

const resources = loadMulti(region.languages.interface, defaultNS)

i18n
  .use(BackendAdapter)
  .use(initReactI18next)
  .init(
    {
      // Use static region as this is only for init
      lng: region.languages.default, // Localization.locale,
      fallbackLng: false, // en
      partialBundledLanguages: true,
      resources: resources.data,
      interpolation: {
        escapeValue: false,
      },
      backend: {
        backend: customBackend,
      },
      appendNamespaceToMissingKey: true,
      saveMissing: true,
      missingKeyHandler: (lngs, ns, key, fallbackValue) => {
        if (lngs.length === 1 && lngs[0] === 'dv') {
          return
        }
        const msg = `Missing key ${ns}:${key} in ${lngs.join(', ')}`
        if (logged[msg]) {
          return
        }
        const tls = i18n.getDataByLanguage(lngs[0])
        if (!tls?.[ns]) {
          // Namespace not loaded yet so don't log it
          return
        }
        logged[msg] = true
        if (AppConfig.isDev) {
          console.log('[i18n] Missing key', { lngs, ns, key, fallbackValue })
        }
        Sentry.captureMessage(msg, {
          level: 'warning',
          tags: {
            location: 'i18n',
            ns,
            key,
            language: lngs[0],
          },
          extra: {
            allLangs: lngs,
          },
        })
      },
      defaultNS,
      cleanCode: true,
      react: {
        useSuspense: false,
        hashTransKey: () => undefined,
      },
    },
    () => {
      // Load defaultNS from remote on app start/reload resources
      customBackend.readMulti([i18n.language], defaultNS)
    }
  )

export default i18n
